import { nanoid } from 'nanoid';
// import { SvelteComponent } from 'svelte';

/**
 * Transform a mixed value array into a clean space separated string
 * @param {string} attrs
 * @example ['flex', null, '', 'w-4', undefined, 'mt-4']
 * @return {string} 'flex w-4 mt-4'
 */
export const attrValue = (attrs: string[]): string => attrs.filter(v => v && v.length).join(' ');

export const shortId = (): string => nanoid(8);

// lost through code minification !!
//https://stackoverflow.com/questions/59541371/how-to-verify-if-prop-passed-is-a-component-type-in-svelte

// export const isSvelteComponent = (component: Object) => {
//   return SvelteComponent.isPrototypeOf(component);
// };

export const setAttribute = (attr: string, node: any, value: string) => {
  node.setAttribute(attr, value);
};
